module.exports = __webpack_public_path__ + "static/media/Expert-Immobilier-Vaud.83d59698.jpg";